import styled from 'styled-components/macro';

const LiveLabelWrapper = styled.span`
  position: relative;
  background-color: #e73458;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 20px;
  border-radius: 50px;

  .round {
    position: absolute;
    background-color: none;
    border: 1px solid ${props => props.theme.colors.white};
    border-radius: 50%;
  }

  .round-1 {
    width: 2.5px;
    height: 2.5px;
    animation-delay: 0s;
    animation-duration: 1s;
    animation-name: rounds;
    animation-direction: alternate;
    animation-iteration-count: infinite;
    animation-fill-mode: backwards;
  }

  .round-2 {
    width: 7.5px;
    height: 7.5px;
    animation-delay: 0.5s;
    animation-duration: 1s;
    animation-name: rounds;
    animation-direction: alternate;
    animation-iteration-count: infinite;
    animation-fill-mode: backwards;
  }

  .round-3 {
    width: 12.5px;
    height: 12.5px;
    animation-delay: 1s;
    animation-duration: 1s;
    animation-name: rounds;
    animation-direction: alternate;
    animation-iteration-count: infinite;
    animation-fill-mode: backwards;
  }

  @keyframes rounds {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

export { LiveLabelWrapper };
